/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAdvisorBookingDetailModel } from '../../models/medical-advisor-booking-detail-model';

export interface ApiMedicalAdvisorConfirmBookingPost$Params {
      body?: MedicalAdvisorBookingDetailModel
}

export function apiMedicalAdvisorConfirmBookingPost(http: HttpClient, rootUrl: string, params?: ApiMedicalAdvisorConfirmBookingPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<string | null>> {
  const rb = new RequestBuilder(rootUrl, apiMedicalAdvisorConfirmBookingPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BookingStrictHttpResponse<string | null>;
    })
  );
}

apiMedicalAdvisorConfirmBookingPost.PATH = '/api/MedicalAdvisor/ConfirmBooking';
